var _rect, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSlogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 2.82353,
    fill: "#2E1834"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.3701 11.1039C6.3701 10.8135 6.34677 10.5114 6.38171 10.2209C6.41645 9.94201 6.49785 9.66318 6.55602 9.39595C6.82324 9.48896 7.11379 9.53542 7.34617 9.67479C8.74045 10.5812 10.1347 11.4991 11.4942 12.4518C11.9822 12.7887 12.3192 12.7423 12.7838 12.4169C14.1897 11.4176 15.6422 10.4648 17.0829 9.51209C17.6291 9.15196 17.9079 9.29133 17.8964 9.96534C17.8847 10.8251 17.8498 11.6966 17.7685 12.5449C17.7453 12.7539 17.5594 13.0095 17.3851 13.149C15.8398 14.2528 14.2711 15.3217 12.7142 16.4023C12.2495 16.7276 11.8196 16.6464 11.378 16.3326C10.0302 15.3914 8.694 14.4386 7.29972 13.5673C6.60258 13.1374 6.26567 12.6261 6.37029 11.8128C6.39342 11.5687 6.3701 11.3364 6.3701 11.1039Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.46094 14.5432C7.73898 15.403 8.88937 16.17 10.028 16.96C10.4347 17.2389 10.4347 17.5991 10.028 17.8895C8.88937 18.668 7.72747 19.4348 6.46094 20.2829C6.46094 18.3309 6.46094 16.5184 6.46094 14.5432Z",
    fill: "#FFCC29"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.719 14.6013C17.719 16.5534 17.719 18.2847 17.719 19.9926C17.6144 20.0158 17.5563 20.0391 17.5332 20.0274C16.3944 19.2838 15.2442 18.5402 14.1171 17.7617C14.0009 17.6803 13.9662 17.2156 14.059 17.1459C15.2094 16.3093 16.3828 15.5076 17.719 14.6013Z",
    fill: "#FFCC29"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8455 8.60953C14.6488 6.86961 13.3691 3.53955 11.7952 3.53955C11.0516 3.53955 10.3133 4.31134 9.71654 5.71257C9.32206 6.63901 9.02942 7.7622 8.95041 8.60844C8.74265 8.65609 8.58789 8.84132 8.58789 9.06317C8.58789 9.32117 8.79694 9.53022 9.05563 9.53022C9.31362 9.53022 9.52267 9.32117 9.52267 9.06317C9.52267 8.86643 9.40097 8.69857 9.22895 8.62968C9.30498 7.81382 9.58968 6.72408 9.97383 5.82216C10.2925 5.0739 10.9527 3.81898 11.7952 3.81898C13.0831 3.81898 14.3805 6.87298 14.5686 8.6276C14.3934 8.6949 14.269 8.86435 14.269 9.06317C14.269 9.32117 14.4779 9.53022 14.7361 9.53022C14.9947 9.53022 15.2037 9.32117 15.2037 9.06317C15.2037 8.84281 15.051 8.65857 14.8454 8.60943L14.8455 8.60953Z",
    fill: "#FEFEFE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlogo);
export default __webpack_public_path__ + "static/media/slogo.1f4146592d5f4d0211e020b28774f199.svg";
export { ForwardRef as ReactComponent };